import { render, staticRenderFns } from "./BottomBarButton.vue?vue&type=template&id=56bc2903"
import script from "./BottomBarButton.vue?vue&type=script&lang=js"
export * from "./BottomBarButton.vue?vue&type=script&lang=js"
import style0 from "./BottomBarButton.vue?vue&type=style&index=0&id=56bc2903&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
